<template>
  <div class="user-card-container">
    <div class="user-card-wrap">
      <div class="avatar">
        <img src="../../../assets/images/homePage/logined.png" alt="" />
      </div>
      <div class="user-right">
        <p class="user-name">{{ userName }}</p>
        <p>您好，欢迎来到智筑通</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.user-card-wrap {
  height: 90px;
  background: #ffffff;
  background-image: url('../imgs/card-bg.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .avatar {
    width: 40px;
    height: 40px;
    margin: 0 16px 0 16px;
    margin-right: 10px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .user-right {
    height: 36px;
  }
  p {
    font-size: 12px;
    color: #333333;
  }
  p.user-name {
    color: #ce2939;
  }
}
</style>
